"use client";

import ColorfulSlider from "@/components/colorful/colorful-slider/colorful-slider";
import FilterBar from "@/components/filter-bar/filter-bar";
import { getGenreSliders } from "@/lib/api/genre/sliders";
import Link from "next/link";
import { useEffect, useState } from "react";
import useSWR from "swr";
import Loading from "../_partials/loading/loading";
import { Sort } from "../_types/sort";

const GenreSliders = ({
	kindObj,
	initialSorts,
	initialSlides,
	initialSearchTerm,
	initialSort,
}: {
	kindObj: any;
	initialSorts: any[];
	initialSlides: any[];
	initialSearchTerm?: string;
	initialSort?: Sort;
}) => {
	const [selectedSort, setSelectedSort] = useState<Sort | undefined>(
		initialSort ?? undefined
	);
	const [searchTerm, setSearchTerm] = useState(initialSearchTerm || "");

	const {
		data: slides,
		mutate,
		isLoading,
	} = useSWR(
		["genre-sliders", kindObj.kind, searchTerm, selectedSort?.value],
		() => getGenreSliders(kindObj.kind, searchTerm, selectedSort),
		{ fallbackData: initialSlides, revalidateOnMount: false }
	);

	useEffect(() => {
		const query = new URLSearchParams();

		searchTerm && query.append("title", searchTerm);
		if (selectedSort) {
			query.append("sortBy", selectedSort.sortBy);
			query.append("direction", selectedSort.direction);
		}

		const qs = query.toString();
		const newUrl = qs
			? `${window.location.pathname}?${qs}`
			: window.location.pathname;

		window.history.replaceState(null, "", newUrl);

		mutate();
	}, [searchTerm, selectedSort, mutate]);

	return (
		<>
			<div className="w-full flex flex-wrap justify-between items-center px-[24px] md:px-[80px] py-4 gap-4">
				<h2 className="text-white text-xl md:text-[32px] font-bold">
					{kindObj?.name}
				</h2>
				<FilterBar
					showSearch
					showSort
					showGenre={false}
					searchTerm={searchTerm}
					setSearchTerm={setSearchTerm}
					activeSort={selectedSort}
					initialSorts={initialSorts}
					setSort={setSelectedSort}
				/>
			</div>
			<div className="my-6">
				{isLoading ? (
					<div className="w-full h-full min-h-screen flex justify-center items-center">
						<Loading />
					</div>
				) : (
					<>
						{slides?.map((data: any, index: number) => (
							<div className={"w-full px-[24px] md:px-[80px] pt-1"} key={index}>
								<div className={"flex items-center justify-between"}>
									<h2 className="text-white text-lg font-semibold mb-[10px] md:mb-6 text-right md:text-[24px]">
										{data?.genre?.persianName}
									</h2>
									<Link
										className={
											"text-xs md:text-[18px] font-semiBold text-custom-pink underline hover:opacity-70"
										}
										href={`/${kindObj?.kind}/genres/${data?.genre?.id}`}
									>
										مشاهده همه
									</Link>
								</div>
								<ColorfulSlider
									id={`subcategory-${index}`}
									slides={data.content}
									kind={kindObj?.kind}
									centeredSlides={false}
								/>
							</div>
						))}
					</>
				)}
			</div>
		</>
	);
};

export default GenreSliders;
